import { render, staticRenderFns } from "./codeSelector.vue?vue&type=template&id=64972a7a&scoped=true"
import script from "./codeSelector.vue?vue&type=script&lang=js"
export * from "./codeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64972a7a",
  null
  
)

export default component.exports